var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"0fef984c768fe084d73ac18224d66c8fabfdf152"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["frontend-web@token-traxx"]={id:"0fef984c768fe084d73ac18224d66c8fabfdf152"};
      